import React, { FC, useContext, useState, useMemo } from 'react';
import Header from 'src/components/organisms/Header';
import { CatalogContext } from 'src/contexts/Catalog';
import CatalogZoom from 'src/components/organisms/CatalogZoom';
import { DesktopOptionsBar } from 'src/components/templates/CatalogPage/DesktopCatalogPage/DesktopOptionsBar';

import { styled } from '@grupoboticario/flora-react';

import { DesktopProductsSection } from './DesktopProductsSection';
import { DesktopSlider } from './DesktopSlider';
import { sendCatalogEvent } from 'src/services/googleAnalytics/helpers/catalog';

const Wrapper = styled('div', {
  background: '$brand-1',
  width: '100%',
  height: '100%',
});

const ContentWrapper = styled('div', {
  width: '100%',
  height: '100%',
  background: '$light-dark-2',
  padding: '0 $8',
  borderRadius: '$large $large 0 0',
  display: 'flex',
  justifyContent: 'center',
});

const CatalogWrapper = styled('div', {
  overflowX: 'initial',
  paddingRight: '$8',
  maxWidth: 'calc((100vh - 124px) * 1.45)',

  variants: {
    productsSection: {
      true: {
        width: '70%',
      },
      false: {
        width: '100%',
      },
    },
  },
});

export const DesktopCatalogPage: FC = () => {
  const [state] = useContext(CatalogContext);
  const [productsSection, setProductsSection] = useState(false);

  const toggleProductsSection = () => {
    setProductsSection(!productsSection);

    productsSection
      ? sendCatalogEvent.closeProductList()
      : sendCatalogEvent.openProductList();

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
  };

  const MemoizedCatalog = useMemo(
    () => (
      <>
        <Header isCatalogViewHeader={true} catalog={state.catalogData} />
        <ContentWrapper>
          <CatalogWrapper productsSection={productsSection}>
            <DesktopOptionsBar
              handleProductDetailClick={toggleProductsSection}
              showProductDetailButton={!productsSection}
            />
            <DesktopSlider
              navigation={productsSection ? 'inside' : 'outside'}
            />
          </CatalogWrapper>
          <DesktopProductsSection
            isOpen={productsSection}
            onCloseClick={toggleProductsSection}
          />
        </ContentWrapper>
      </>
    ),
    [state.catalogData, productsSection],
  );

  return (
    <Wrapper>
      {MemoizedCatalog}
      {state.isZoomActive && <CatalogZoom />}
    </Wrapper>
  );
};
